import Vue from 'vue';
import { String } from 'typescript-string-operations';

Vue.prototype.$string = String;
